import React from 'react';
import { Menu } from 'lucide-react';
import NotificacoesDropdown from '../NotificacoesDropdown';
import MannuAIWidget from '../MannuAIWidget';
import { BrowserAssistanceNotice } from '../config/BrowserAssistance';

export default function Header({ title, subtitle, token, setCurrentPage, onOpenMobileSidebar }) {
  return (
    <header className="lbcc-system-header sticky top-0 z-40 flex min-h-16 items-center justify-between border-b px-4 py-3 sm:px-6">
      <div className="flex min-w-0 items-center gap-3">
        <button
          type="button"
          onClick={onOpenMobileSidebar}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-slate-200 text-slate-700 lg:hidden"
          data-testid="mobile-sidebar-open-button"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="min-w-0">
        <h1 className="text-xl font-bold text-[#0D2B4A]">{title}</h1>
        {subtitle && <p className="hidden text-sm text-slate-500 md:block">{subtitle}</p>}
        </div>
      </div>
      
      <div className="flex items-center gap-2 sm:gap-4">
        {/* Notifications */}
        {token && (
          <>
            <BrowserAssistanceNotice key={token} token={token} />
            <MannuAIWidget token={token} />
            <NotificacoesDropdown 
              token={token} 
              onNavigate={(target) => {
                if (target?.kind === 'mannu') {
                  window.dispatchEvent(new CustomEvent('open-mannu-from-notification', { detail: target }));
                  if (setCurrentPage) {
                    setCurrentPage('dashboard');
                  }
                  return;
                }
                if (target?.tarefaId) {
                  window.sessionStorage.setItem('pendingTaskNavigation', JSON.stringify(target));
                  window.dispatchEvent(new CustomEvent('open-task-from-notification', { detail: target }));
                }
                if (setCurrentPage) {
                  setCurrentPage('tarefas');
                }
              }}
            />
          </>
        )}
      </div>
    </header>
  );
}
